/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Catalog_RegenerateInputs */

const cs_property_ai_catalog_regenerate = /** @type {(inputs: Property_Ai_Catalog_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat znovu`)
};

const en_property_ai_catalog_regenerate = /** @type {(inputs: Property_Ai_Catalog_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate`)
};

/**
* | output |
* | --- |
* | "Regenerate" |
*
* @param {Property_Ai_Catalog_RegenerateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_regenerate = /** @type {((inputs?: Property_Ai_Catalog_RegenerateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_RegenerateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_regenerate(inputs)
	return cs_property_ai_catalog_regenerate(inputs)
});